import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import "../../../assets/topstudio/styles/role-dice.css";
import "../../../assets/topstudio/styles/color-game.css";
import useSocket from "../../../hooks/useSocket";
import BetfairCasinoBetslipWeb from "../betfair-games/betfair_casino_betslip_web";
import axiosInstance from "../../../utils/axiosInstance";
import RollDiceRules from "./pop-up/rolldice-rules";
import Volume from "./Volume";

import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import RollDiceResult from "./tp-result/RollDiceResult.jsx";

import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

const RD_DICE_SIZE = 80;
const RD_HALF = RD_DICE_SIZE / 2;

export default function RollDice() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [showRules, setShowRules] = useState(false);
  const [dice1, setDice1] = useState(1);
  const [dice2, setDice2] = useState(2);
  const [isRolling, setIsRolling] = useState(false);
  const [lastStatus, setLastStatus] = useState("");
  const diceRollTimerRef = useRef(null);
  const [resultMsg, setResultMsg] = useState("Place Your Bet");
  const [lastResults, setLastResults] = useState([]);

  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [betList, setBetList] = useState([]);
  const [totalBets, setTotalBets] = useState(0);
  const [lotteryUO, setlotteryUO] = useState(1);

  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [profileData, setProfileData] = useState(null);

  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [resultData, setResultData] = useState([]);

  const { data, isConnected } = useSocket({
    marketId: null,
    mtype: "virtual",
    type: "rolldice_virtual"
  });
  //console.log("Socket data:", data);

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  function lotteryOverUnderFunc(data = 1) {
    setlotteryUO(data);
  }

  let eventStatus = "";
  let roundId = "";
  let timeLeftGame = "";

  let suspend1 = "";
  let b1 = 0;
  let b2 = 0;
  let b3 = 0;
  let b4 = 0;
  let l1 = 0;
  let l2 = 0;
  let l3 = 0;
  let l4 = 0;
  let betfairOdds = null;
  let lastResult = null;
  if (
    data != null &&
    data.data?.data !== null &&
    data.data?.data !== undefined
  ) {
    betfairOdds = data.data.data;

    //updateUserData(data?.user);
    //console.log(betfairOdds);
    roundId = betfairOdds.evt_id;
    eventStatus = betfairOdds.evt_status;
    timeLeftGame = betfairOdds.left_time;
    if (timeLeftGame == 1) {
      timeLeftGame = 0;
    }
    timeLeftGame = parseInt(timeLeftGame);
    suspend1 = betfairOdds.suspend1;
    b1 = betfairOdds.b1;
    b2 = betfairOdds.b2;
    b3 = betfairOdds.b3;
  }

  // Dice rolling animation logic
  useEffect(() => {
    if (!betfairOdds) return;

    // On OPEN: reset dice to random values
    if (
      lastStatus !== betfairOdds.evt_status &&
      betfairOdds.evt_status === "OPEN"
    ) {
      clearTimeout(diceRollTimerRef.current);
      setIsRolling(false);
      setDice1(Math.floor(Math.random() * 6) + 1);
      setDice2(Math.floor(Math.random() * 6) + 1);
    }

    // On CLOSED: start rolling immediately
    if (
      lastStatus !== betfairOdds.evt_status &&
      betfairOdds.evt_status === "CLOSED"
    ) {
      setIsRolling(true);
    }

    // Once rollResult values arrive (non-zero), settle dice after animation
    if (
      betfairOdds.rollResult &&
      betfairOdds.rollResult2 &&
      parseInt(betfairOdds.rollResult) !== 0 &&
      parseInt(betfairOdds.rollResult2) !== 0 &&
      isRolling
    ) {
      const d1 = parseInt(betfairOdds.rollResult) || 1;
      const d2 = parseInt(betfairOdds.rollResult2) || 1;
      clearTimeout(diceRollTimerRef.current);
      diceRollTimerRef.current = setTimeout(() => {
        setDice1(d1);
        setDice2(d2);
        setIsRolling(false);
      }, 1500);
    }

    if (lastStatus !== betfairOdds.evt_status) {
      setLastStatus(betfairOdds.evt_status);
    }
  }, [betfairOdds]);

  // Cleanup timer on unmount
  useEffect(() => () => clearTimeout(diceRollTimerRef.current), []);

  const showBetfairBetSlip = (bettype, teamname, price, game_type) => {
    let placeBetObject = {
      amount: 0,
      catmid: "",
      market_type: "m",
      game_name: "rolldice_virtual"
    };
    placeBetObject.catmid = roundId;
    //console.log(placeBetObject);
    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    placeBetObject.game_type = game_type;

    setPlaceBetObject(placeBetObject);
    setShowBetSlip(true);
    //showBetfairSlipStatus = true;
  };

  const closeBetSlip = () => {
    setShowBetSlip(false);
  };

  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setProfileData(data);
    } catch (error) {
      //console.log("Failed to load profile data:", error);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  /// place bet ///
  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;

    try {
      const response = await axiosInstance.post(
        "/rolldice-virtual",
        placeBetObject
      );
      //console.log(response);
      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
        getBook();
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  const getBook = async () => {
    let bookObject = {};
    bookObject.roundId = roundId; // roundId;
    bookObject.game_type = "rolldice-virtual";
    //console.log(roundId);
    const response = await axiosInstance.post("/tp20-book", bookObject);
    //console.log("response->", response.data);
    ///
    let bet_list = response.data.bets_list;

    if (bet_list.length > 0) {
      setTotalBets(bet_list.length);
      setBetList(bet_list);
    } else {
      setBetList([]);
    }

    ///
    return response;
  };

  useEffect(
    (roundId) => {
      getBook();
    },
    [roundId]
  ); // Empty dependency array
  /// place bet ///
  //////
  const diceClassMap = {
    1: "show-1",
    2: "show-2",
    3: "show-3",
    4: "show-4",
    5: "show-5",
    6: "show-6"
  };

  /*useEffect(() => {
    const interval = setInterval(() => {
      setDice1(Math.floor(Math.random() * 6) + 1);
      setDice2(Math.floor(Math.random() * 6) + 1);
      setResultMsg("Rolling...");
      setLastResults((prev) => {
        const next = [Math.floor(Math.random() * 12) + 1, ...prev];
        return next.slice(0, 10);
      });
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    document.documentElement.classList.add("roll-dice-bg-black");
    document.documentElement.classList.add("h-100");

    return () => {
      document.documentElement.classList.remove("roll-dice-bg-black");
      document.documentElement.classList.remove("h-100");
    };
  }, []);*/

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "rolldice_virtual";

    //console.log("BEFORE API CALL");

    const response = await axiosInstance.post("/teenpatti-results", resultObj);
    //console.log("FULL RESPONSE", response.data);
    //console.log("AFTER API CALL");

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };

  const rolldiceStyles = `
    .rolldice-dicegame {
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: auto;
      height: auto;
      perspective: 600px;
      gap: 60px;
      padding: 30px 0;
    }
    .rolldice-dice {
      width: ${RD_DICE_SIZE}px;
      height: ${RD_DICE_SIZE}px;
      position: relative;
      transform-style: preserve-3d;
      transition: transform 0.4s ease-out;
    }
    .rolldice-dice.rolldice-rolling {
      animation: rolldiceRoll 1.5s ease-in-out infinite;
      transition: none !important;
    }
    .rolldice-side {
      position: absolute;
      background-color: #fff;
      border-radius: 5px;
      width: ${RD_DICE_SIZE}px;
      height: ${RD_DICE_SIZE}px;
      top: 0;
      left: 0;
      border: none;
      box-sizing: border-box;
      box-shadow: 0 0 0 1px #fff;
    }
    .rolldice-side:nth-child(1) { transform: translateZ(${RD_HALF}px); }
    .rolldice-side:nth-child(2) { transform: rotateY(180deg) translateZ(${RD_HALF}px); }
    .rolldice-side:nth-child(3) { transform: rotateY(-90deg) translateZ(${RD_HALF}px); }
    .rolldice-side:nth-child(4) { transform: rotateX(90deg) translateZ(${RD_HALF}px); }
    .rolldice-side:nth-child(5) { transform: rotateX(-90deg) translateZ(${RD_HALF}px); }
    .rolldice-side:nth-child(6) { transform: rotateY(90deg) translateZ(${RD_HALF}px); }
    .rolldice-dot {
      position: absolute;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-color: #ef233c;
      box-shadow: inset 2px 2px #d90429;
    }
    /* dot positions */
    .rolldice-two-1, .rolldice-three-1, .rolldice-four-1, .rolldice-five-1, .rolldice-six-1 { top: 10%; left: 10%; }
    .rolldice-four-3, .rolldice-five-3, .rolldice-six-4 { top: 10%; left: 70%; }
    .rolldice-one-1, .rolldice-three-2, .rolldice-five-5 { top: 39%; left: 41%; }
    .rolldice-four-2, .rolldice-five-2, .rolldice-six-3 { top: 75%; left: 10%; }
    .rolldice-two-2, .rolldice-three-3, .rolldice-four-4, .rolldice-five-4, .rolldice-six-6 { top: 75%; left: 71%; }
    .rolldice-six-2 { top: 43%; left: 10%; }
    .rolldice-six-5 { top: 40%; left: 70%; }
    /* show faces */
    .rolldice-show1 { transform: rotateX(0deg) rotateY(0deg); }
    .rolldice-show2 { transform: rotateX(0deg) rotateY(180deg); }
    .rolldice-show3 { transform: rotateY(90deg); }
    .rolldice-show4 { transform: rotateX(-90deg); }
    .rolldice-show5 { transform: rotateX(90deg); }
    .rolldice-show6 { transform: rotateY(-90deg); }
    @keyframes rolldiceRoll {
      0%   { transform: rotateX(0deg)   rotateY(0deg)   rotateZ(0deg); }
      25%  { transform: rotateX(180deg) rotateY(180deg) rotateZ(0deg); }
      50%  { transform: rotateX(360deg) rotateY(0deg)   rotateZ(180deg); }
      75%  { transform: rotateX(180deg) rotateY(360deg) rotateZ(180deg); }
      100% { transform: rotateX(360deg) rotateY(360deg) rotateZ(360deg); }
    }
    .rolldice-overlayClass {
      position: absolute !important;
      height: 100% !important;
      width: 100% !important;
      justify-content: center;
      font-family: monospace;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.5);
      backdrop-filter: blur(10px);
      align-items: center;
      z-index: 999;
      display: flex;
      flex-direction: column;
    }
    .rolldice-overlayClass .overlay-text {
      color: #fff;
      font-size: 22px;
      font-weight: bold;
      text-transform: uppercase;
    }
    .table-box-header2 {
      padding-bottom: 5px;
      padding-top: 0px !important;
    }
  `;

  return (
    <div className="access-role-dice roll-dice-bg-black min-h-screen">
      <ClientLayoutWithOutHeader showLoader={false}>
        <style>
          {rolldiceStyles}
          {`.access-color .casino-timer {
            position: absolute;
            right: 18px;
            z-index: 1000;
          }`}
        </style>
        <div className="details-tabs-wrapper1">
          <div className="wrapper">
            <TPStudioSidebar open={open} />
          </div>

          <div className="lobby-ctn BPGmaindiv">
            <TpStudioHeader setOpen={setOpen} open={open} />
          </div>
          <div className="row">
            <div className="col-md-8">
              <div className="table-box-header2">
                <div className="row no-gutters">
                  <div
                    className="col-6"
                    style={{ color: "white", fontSize: "18px" }}
                  >
                    Roll Dice
                  </div>
                  <div
                    className="col-6 col-md-6 inline-block Gameidcol text-right"
                    style={{ marginTop: "4px" }}
                  >
                    <div
                      role="group"
                      aria-label="Second group"
                      className="btn-group btn-group-sm mr-2"
                    >
                      <button
                        style={{ fontSize: "14px" }}
                        type="button"
                        id="Alltab"
                        className={
                          activeTabIndex == 1
                            ? "tablink btn btn-primary bbactive"
                            : "tablink btn btn-primary"
                        }
                        onClick={() => activeTab(1)}
                      >
                        Game
                      </button>
                      <button
                        style={{ fontSize: "14px" }}
                        type="button"
                        id="RESULTStab"
                        className={
                          activeTabIndex == 2
                            ? "tablink btn btn-primary bbactive"
                            : "tablink btn btn-primary"
                        }
                        onClick={() => activeTab(2)}
                      >
                        Results
                      </button>
                      <button
                        style={{ fontSize: "14px" }}
                        type="button"
                        className="tablink btn btn-primary"
                        onClick={() => setShowRules(true)}
                      >
                        Rules
                      </button>

                      <div className="col-12 timerDiv2 mb-negative-24">
                        <RollDiceRules
                          show={showRules}
                          onClose={() => setShowRules(false)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {activeTabIndex == 1 && (
                <>
                  <div
                    style={{
                      background: "#130a21",
                      paddingTop: 40,
                      position: "relative"
                    }}
                  >
                    {eventStatus === "OPEN" && (
                      <div className="rolldice-overlayClass">
                        <div className="overlay-text">New Round</div>
                        <div className="overlay-text">Betting Open</div>
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center"
                      }}
                      id="videos"
                      className="access-color"
                    >
                      <div className="rolldice-dicegame">
                        {/* DICE 1 */}
                        <div
                          className={`rolldice-dice ${
                            isRolling
                              ? "rolldice-rolling"
                              : `rolldice-show${dice1}`
                          }`}
                        >
                          <div className="rolldice-side">
                            <div className="rolldice-dot rolldice-one-1" />
                          </div>
                          <div className="rolldice-side">
                            <div className="rolldice-dot rolldice-two-1" />
                            <div className="rolldice-dot rolldice-two-2" />
                          </div>
                          <div className="rolldice-side">
                            <div className="rolldice-dot rolldice-three-1" />
                            <div className="rolldice-dot rolldice-three-2" />
                            <div className="rolldice-dot rolldice-three-3" />
                          </div>
                          <div className="rolldice-side">
                            <div className="rolldice-dot rolldice-four-1" />
                            <div className="rolldice-dot rolldice-four-2" />
                            <div className="rolldice-dot rolldice-four-3" />
                            <div className="rolldice-dot rolldice-four-4" />
                          </div>
                          <div className="rolldice-side">
                            <div className="rolldice-dot rolldice-five-1" />
                            <div className="rolldice-dot rolldice-five-2" />
                            <div className="rolldice-dot rolldice-five-3" />
                            <div className="rolldice-dot rolldice-five-4" />
                            <div className="rolldice-dot rolldice-five-5" />
                          </div>
                          <div className="rolldice-side">
                            <div className="rolldice-dot rolldice-six-1" />
                            <div className="rolldice-dot rolldice-six-2" />
                            <div className="rolldice-dot rolldice-six-3" />
                            <div className="rolldice-dot rolldice-six-4" />
                            <div className="rolldice-dot rolldice-six-5" />
                            <div className="rolldice-dot rolldice-six-6" />
                          </div>
                        </div>

                        {/* DICE 2 */}
                        <div
                          className={`rolldice-dice ${
                            isRolling
                              ? "rolldice-rolling"
                              : `rolldice-show${dice2}`
                          }`}
                        >
                          <div className="rolldice-side">
                            <div className="rolldice-dot rolldice-one-1" />
                          </div>
                          <div className="rolldice-side">
                            <div className="rolldice-dot rolldice-two-1" />
                            <div className="rolldice-dot rolldice-two-2" />
                          </div>
                          <div className="rolldice-side">
                            <div className="rolldice-dot rolldice-three-1" />
                            <div className="rolldice-dot rolldice-three-2" />
                            <div className="rolldice-dot rolldice-three-3" />
                          </div>
                          <div className="rolldice-side">
                            <div className="rolldice-dot rolldice-four-1" />
                            <div className="rolldice-dot rolldice-four-2" />
                            <div className="rolldice-dot rolldice-four-3" />
                            <div className="rolldice-dot rolldice-four-4" />
                          </div>
                          <div className="rolldice-side">
                            <div className="rolldice-dot rolldice-five-1" />
                            <div className="rolldice-dot rolldice-five-2" />
                            <div className="rolldice-dot rolldice-five-3" />
                            <div className="rolldice-dot rolldice-five-4" />
                            <div className="rolldice-dot rolldice-five-5" />
                          </div>
                          <div className="rolldice-side">
                            <div className="rolldice-dot rolldice-six-1" />
                            <div className="rolldice-dot rolldice-six-2" />
                            <div className="rolldice-dot rolldice-six-3" />
                            <div className="rolldice-dot rolldice-six-4" />
                            <div className="rolldice-dot rolldice-six-5" />
                            <div className="rolldice-dot rolldice-six-6" />
                          </div>
                        </div>
                      </div>

                      <div className="casino-timer">
                        <svg
                          className="progressBar"
                          x="0px"
                          y="0px"
                          viewBox="0 0 80 80"
                        >
                          <path
                            className="track track_red"
                            d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                          />
                          <path
                            className="fill fill_red"
                            d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                            style={{
                              strokeDashoffset: "-219.99078369140625"
                            }}
                          />
                          <text className="value" x="50%" y="55%">
                            {timeLeftGame}
                          </text>
                        </svg>
                      </div>
                    </div>

                    <div className="results-div" style={{ marginTop: 30 }}>
                      {lastResults.map((r, i) => (
                        <button key={i} className="video-button">
                          {r}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="results-div" id="lastresults">
                        <button
                          class="video-button"
                          style={{ backgroundColor: "#000000" }}
                        >
                          5
                        </button>
                        <button
                          class="video-button"
                          style={{ backgroundColor: "#000000" }}
                        >
                          10
                        </button>
                        <button
                          class="video-button"
                          style={{ backgroundColor: "#000000" }}
                        >
                          11
                        </button>
                        <button
                          class="video-button"
                          style={{ backgroundColor: "#000000" }}
                        >
                          7
                        </button>
                        <button
                          class="video-button"
                          style={{ backgroundColor: "#000000" }}
                        >
                          5
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="card-body" style={{ padding: 0 }}>
                    <div style={{ marginTop: 0, textAlign: "center" }}>
                      {/*- -*/}
                      <button
                        data={1}
                        className={`btn singleBtn lotteryBtn ${
                          lotteryUO == 1 ? "active" : ""
                        }`}
                        onClick={() => lotteryOverUnderFunc(1)}
                      >
                        UNDER
                      </button>
                      <button
                        data={2}
                        className={`btn tripleBtn lotteryBtn ${
                          lotteryUO == 2 ? "active" : ""
                        }`}
                        onClick={() => lotteryOverUnderFunc(2)}
                      >
                        OVER
                      </button>
                      {/*- -*/}
                    </div>
                    <div
                      className=""
                      style={{
                        background: "black",
                        marginLeft: 0,
                        padding: 8,
                        width: "100%",
                        fontSize: 20,
                        textAlign: "center"
                      }}
                    >
                      <span
                        id="lotteryTitle"
                        style={{ color: "#fff", marginLeft: 5 }}
                      >
                        {lotteryUO == 1 ? "UNDER" : "OVER"}
                      </span>
                    </div>
                    <div
                      id="lotteryBet"
                      style={{ marginBottom: 20, background: "#120a21" }}
                    >
                      <div
                        style={{ marginTop: 10, textAlign: "center" }}
                        className={`${lotteryUO == 1 ? "" : "hides"}`}
                        id="card_list_1"
                      >
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={3}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "3", 15.3, "under")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b3"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">3</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat3"
                          >
                            15.3
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={4}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "4", 8.15, "under")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b4"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">4</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat4"
                          >
                            8.15
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={5}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "5", 4.25, "under")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b5"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">5</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat5"
                          >
                            4.25
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={6}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "6", 3.1, "under")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b6"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">6</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat6"
                          >
                            3.1
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={7}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "7", 2.3, "under")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b7"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">7</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat7"
                          >
                            2.3
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={8}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "8", 1.5, "under")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b8"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">8</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat8"
                          >
                            1.5
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={9}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "9", 1.3, "under")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b9"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">9</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat9"
                          >
                            1.3
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={10}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "10", 1.15, "under")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b10"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">10</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat10"
                          >
                            1.15
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={11}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "11", 1.05, "under")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b11"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">11</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat11"
                          >
                            1.05
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                      </div>

                      <div
                        style={{ marginTop: 10, textAlign: "center" }}
                        className={`${lotteryUO == 2 ? "" : "hides"}`}
                        id="card_list_2"
                      >
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={3}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "3", 1.05, "over")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b3"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">3</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat3"
                          >
                            1.05
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={4}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "4", 1.15, "over")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b4"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">4</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat4"
                          >
                            1.15
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={5}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "5", 1.3, "over")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b5"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">5</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat5"
                          >
                            1.3
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={6}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "6", 1.5, "over")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b6"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">6</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat6"
                          >
                            1.5
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={7}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "7", 2.3, "over")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b7"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">7</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat7"
                          >
                            2.3
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={8}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "8", 3.1, "over")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b8"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">8</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat8"
                          >
                            3.1
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={9}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "9", 4.25, "over")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b9"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">9</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat9"
                          >
                            4.25
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={10}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "10", 8.15, "over")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b10"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">10</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat10"
                          >
                            8.15
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                        <button
                          className="back-btn cardGet span1details"
                          data-market-type="f"
                          data-teamname={11}
                          data-bettype="b"
                          style={{
                            margin: "0 5px",
                            padding: 0,
                            position: "relative",
                            border: "none",
                            marginTop: 10,
                            background: "transparent"
                          }}
                          onClick={() =>
                            showBetfairBetSlip("b", "11", 15.3, "over")
                          }
                        >
                          <span
                            style={{
                              color: "#fff",
                              fontSize: 14,
                              display: "none"
                            }}
                            className="odd"
                            id="b11"
                          >
                            2.15
                          </span>
                          <div className="rule__dice">11</div>
                          <span
                            style={{ color: "#fff", fontSize: 14 }}
                            className="printGameOdds"
                            id="livestat11"
                          >
                            15.3
                          </span>
                          <input
                            type="hidden"
                            className="game_type"
                            defaultValue="under"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {activeTabIndex == 2 && (
                <RollDiceResult resultData={resultData} />
              )}
            </div>

            <div className="col-md-4">
              {showBetSlipPopup && (
                <TPPopUpBetSlip
                  closeBetSlipParent={closeBetSlipMobile}
                  betObj={placeBetObject}
                  placeBetParent={placeBet}
                  betButtonShow={betButtonShow}
                  betErrorMessageObj={betErrorMessageObj}
                  betButtonShowLoaderShow={betButtonShowLoaderShow}
                  profileData={profileData}
                />
              )}

              <TeenPattisCasinoBetslipWeb
                showBetSlip={showBetSlip}
                placeBetObject={placeBetObject}
                closeBetSlipParent={closeBetSlip}
                placeBetParent={placeBet}
                betErrorMessageObj={betErrorMessageObj}
                profileData={profileData}
              ></TeenPattisCasinoBetslipWeb>

              <div className="card" style={{ border: 0 }}>
                <div
                  className="card-header"
                  style={{
                    padding: "0px",
                    background: "#23292d"
                  }}
                >
                  <h2
                    className="mb-0"
                    style={{ background: "var(--theme-color)" }}
                  >
                    <button
                      className="btn btn-link btn-block text-left"
                      style={{
                        color: "white",
                        textDecoration: "none"
                      }}
                    >
                      My Bets
                    </button>
                  </h2>
                </div>

                <div
                  className="collapse show"
                  style={{
                    backgroundColor: "#2e3438"
                  }}
                >
                  <div className="card-body" style={{ padding: 0 }}>
                    <div className="table-responsive" id="refreshhistory">
                      <table className="table" style={{ marginBottom: 0 }}>
                        <thead>
                          <tr>
                            <th>Runner</th>
                            <th>Price</th>
                            <th>Size</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {betList.length > 0 ? (
                            betList.map((item, index) => (
                              <tr
                                style={{
                                  background:
                                    item.type == "b" ? "#e9f6fc" : "#fce3e4",
                                  color: "#000",
                                  fontSize: "15px",
                                  textAlign: "center"
                                }}
                              >
                                <td
                                  style={{
                                    textAlign: "left",
                                    padding: "15px",
                                    display: "table-cell",
                                    padding: "5px"
                                  }}
                                >
                                  {item.rnr}- {item.cat_mid}
                                </td>
                                <td
                                  style={{
                                    display: "table-cell",
                                    textAlign: "left",
                                    padding: "5px"
                                  }}
                                >
                                  {item.rate}
                                </td>
                                <td
                                  style={{
                                    display: "table-cell",
                                    textAlign: "left",
                                    padding: "5px"
                                  }}
                                >
                                  {item.amnt}
                                </td>
                                <td></td>
                              </tr>
                            ))
                          ) : (
                            <tr></tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ClientLayoutWithOutHeader>
    </div>
  );
}
